import { call, put } from 'redux-saga/effects';
import {
    API_BASE_URL,
    getRequest
} from '../../../api';

import {
    setApplicationLogLoading,

    getApplicationLogsSuccess,
    getApplicationLogsFail,

    getApplicationLogSuccess,
    getApplicationLogFail,

    getApplicationLogsByModuleSuccess,
    getApplicationLogsByModuleFail,

    getApplicationLogsByUserSuccess,
    getApplicationLogsByUserFail,

    getMyActivitySummarySuccess,
    getMyActivitySummaryFail,
} from '../actions/applicationLogActions';

// =========================
// GET ALL LOGS
// =========================
export function* getApplicationLogsSaga() {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/application-logs`;

    yield put(setApplicationLogLoading(true));

    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getApplicationLogsSuccess(resp.data));
        yield put(setApplicationLogLoading(false));
    } catch (error) {
        yield put(getApplicationLogsFail(error.message));
        yield put(setApplicationLogLoading(false));
    }
}

// =========================
// GET LOG BY ID
// =========================
export function* getApplicationLogSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/application-logs/${action.payload.id}`;

    yield put(setApplicationLogLoading(true));

    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getApplicationLogSuccess(resp.data));
        yield put(setApplicationLogLoading(false));
    } catch (error) {
        yield put(getApplicationLogFail(error.message));
        yield put(setApplicationLogLoading(false));
    }
}

// =========================
// GET LOGS BY MODULE
// =========================
export function* getApplicationLogsByModuleSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/application-logs/module/${action.payload.module}`;

    yield put(setApplicationLogLoading(true));

    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getApplicationLogsByModuleSuccess(resp.data));
        yield put(setApplicationLogLoading(false));
    } catch (error) {
        yield put(getApplicationLogsByModuleFail(error.message));
        yield put(setApplicationLogLoading(false));
    }
}

// =========================
// GET LOGS BY USER
// =========================
export function* getApplicationLogsByUserSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/application-logs/user/${action.payload.targetUserId}`;

    yield put(setApplicationLogLoading(true));

    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getApplicationLogsByUserSuccess(resp.data));
        yield put(setApplicationLogLoading(false));
    } catch (error) {
        yield put(getApplicationLogsByUserFail(error.message));
        yield put(setApplicationLogLoading(false));
    }
}

// =========================
// GET MY ACTIVITY SUMMARY
// =========================
export function* getMyActivitySummarySaga(action) {
    const token = sessionStorage.getItem('token');
    const months = action.payload?.months || 9;
    const url = `${API_BASE_URL}/api/application-logs/me/activity?months=${months}`;

    try {
        const resp = yield call(getRequest, { url, token });
        yield put(getMyActivitySummarySuccess(resp.data));
    } catch (error) {
        yield put(getMyActivitySummaryFail(error.message));
    }
}
